(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["icraft-m6-review-photos"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('icraft-m6-photos')) {
  customElements.define('icraft-m6-photos', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.root = this.closest('.icraft-global-reviews');
      this.dialog = this.querySelector('dialog');
      if (!this.root || !this.dialog) return;
      this.photos = Array.from(this.querySelectorAll('[data-m6-photo]'));
      this.root.addEventListener('click', (event) => {
        const link = event.target.closest('[data-m6-photo]');
        if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || !this.dialog.showModal) return;
        const photo = this.photos.find(p => p.dataset.m6Photo === link.dataset.m6Photo);
        if (!photo) return;
        event.preventDefault();
        this.opener = link;
        this.group = this.photos.filter(p => p.dataset.reviewId === photo.dataset.reviewId);
        this.index = this.group.indexOf(photo);
        this.showPhoto();
        this.dialog.showModal();
      }, options);
      this.dialog.querySelector('[data-photo-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.querySelector('[data-photo-prev]').addEventListener('click', () => this.move(-1), options);
      this.dialog.querySelector('[data-photo-next]').addEventListener('click', () => this.move(1), options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); this.move(event.key === 'ArrowLeft' ? -1 : 1);
        }
      }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        const destination = this.destination;
        this.destination = null;
        if (destination) {
          let parent = destination;
          while (parent && parent !== this.root) {
            if (parent.tagName === 'DETAILS') parent.open = true;
            parent = parent.parentElement;
          }
          destination.tabIndex = -1;
          destination.focus({preventScroll:true});
          destination.scrollIntoView({block:'center',behavior:'instant'});
        } else if (this.opener && this.opener.isConnected) this.opener.focus({preventScroll:true});
      }, options);
      this.dialog.querySelector('[data-photo-review]').addEventListener('click', event => {
        event.preventDefault();
        const id = this.group[this.index].dataset.reviewId;
        this.destination = Array.from(this.root.querySelectorAll('[data-source-review-id]')).find(r => r.dataset.sourceReviewId === id);
        this.dialog.close();
      }, options);
    }
    move(delta) {
      this.index = Math.max(0, Math.min(this.group.length - 1, this.index + delta));
      this.showPhoto();
    }
    showPhoto() {
      const photo = this.group[this.index];
      const image = this.dialog.querySelector('.icraft-photo-full');
      const loading = this.dialog.querySelector('[data-photo-loading]');
      const error = this.dialog.querySelector('[data-photo-error]');
      loading.hidden = false;
      error.hidden = true;
      image.style.visibility = 'hidden';
      image.onload = () => { image.style.visibility = 'visible'; loading.hidden = true; };
      image.onerror = () => { loading.hidden = true; error.hidden = false; };
      image.src = photo.href;
      image.alt = photo.querySelector('img').alt;
      this.dialog.querySelector('[data-photo-original]').href = photo.href;
      this.dialog.querySelector('.icraft-photo-caption').textContent = photo.dataset.author + ' · AutoFull.com';
      this.dialog.querySelector('[data-photo-position]').textContent = (this.index + 1) + ' / ' + this.group.length;
      this.dialog.querySelector('[data-photo-prev]').disabled = this.index === 0;
      this.dialog.querySelector('[data-photo-next]').disabled = this.index === this.group.length - 1;
      this.dialog.querySelector('[data-photo-prev]').hidden = this.group.length === 1;
      this.dialog.querySelector('[data-photo-next]').hidden = this.group.length === 1;
    }
    disconnectedCallback() {
      if (this.dialog && this.dialog.open) this.dialog.close();
      this.controller?.abort(); this.controller = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["icraft-product-content"] && !Shopify.designMode) return;
  try {
    (() => {
  const pageReady = new Promise(resolve => {
    const idle = () => 'requestIdleCallback' in window ? window.requestIdleCallback(resolve, {timeout: 2000}) : window.setTimeout(resolve, 0);
    if (document.readyState === 'complete') idle();
    else window.addEventListener('load', idle, {once: true});
  });
  if (!customElements.get('icraft-deferred-media')) {
    customElements.define('icraft-deferred-media', class extends HTMLElement {
      connectedCallback() {
        this.events = new AbortController();
        const button = this.querySelector('.js-load-media');
        if (!button) return;
        button.disabled = true;
        pageReady.then(() => {if (this.isConnected) {this.ready = true;button.disabled = false;}});
        button.addEventListener('click', () => this.loadContent(), {signal: this.events.signal});
      }
      disconnectedCallback() {this.events?.abort();this.querySelector('video')?.pause();}
      loadContent() {
        if (!this.ready) return;
        window.pauseAllMedia?.();
        if (!this.hasAttribute('loaded')) {
          const content = this.querySelector('template')?.content.firstElementChild;
          if (!content) return;
          this.append(content.cloneNode(true));
          this.setAttribute('loaded', '');
        }
        const video = this.querySelector('video');
        if (video) video.play().catch(() => {video.controls = true;});
        this.querySelector('video,iframe')?.focus();
      }
    });
  }
  if (!customElements.get('icraft-product-content')) {
    customElements.define('icraft-product-content', class extends HTMLElement {
      connectedCallback() {
        this.events = new AbortController();
        this.tabs = [...this.querySelectorAll('[role=tab]')];
        this.panels = [...this.querySelectorAll('[data-icraft-panel]')];
        if (!this.tabs.length) return;
        this.querySelector('.icraft-tabs').hidden = false;
        this.select(this.tabs.find(tab => tab.getAttribute('aria-controls').endsWith(`-${this.dataset.defaultTab}`)) || this.tabs[0]);
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(tab), {signal: this.events.signal});
          tab.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            else if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else return;
            event.preventDefault();this.select(this.tabs[next]);this.tabs[next].focus();
          }, {signal: this.events.signal});
        });
        const product = this.closest('.icraft-product');
        this.initPurchaseScroll(product);
        const openReviewAnchor = () => {
          const destination = document.getElementById(location.hash.slice(1));
          if (!destination || !this.contains(destination) || !destination.closest('[data-icraft-panel="reviews"]')) return;
          this.select(this.tabs[0]);
          requestAnimationFrame(() => {
            if (this.isConnected) destination.scrollIntoView({block: 'start', behavior: 'instant'});
          });
        };
        const questionResult = this.querySelector('[data-qa-result]');
        if (questionResult) {
          this.select(this.tabs[0]);
          requestAnimationFrame(() => questionResult.scrollIntoView({block: 'center'}));
        } else {
          openReviewAnchor();
        }
        window.addEventListener('hashchange', openReviewAnchor, {signal: this.events.signal});
        const initialUrl = new URL(location.href);
        const previewParams = ['view', 'preview_theme_id'].filter(key => initialUrl.searchParams.has(key)).map(key => [key, initialUrl.searchParams.get(key)]);
        product.addEventListener('on:variant:change', event => {
          const variant = event.detail?.variant;
          const delivery = product.querySelector('.icraft-delivery');
          if (delivery) {
            const stocked = delivery.dataset.stockedVariants.split(',').includes(String(variant?.id));
            const state = !variant?.available ? 'soldout' : stocked ? 'available' : 'backorder';
            delivery.querySelectorAll('[data-dispatch-state]').forEach(item => {item.hidden = item.dataset.dispatchState !== state;});
          }
          this.querySelectorAll('[data-icraft-colour-index]').forEach(item => {item.textContent = variant?.options[Number(item.dataset.icraftColourIndex)] || '—';});
          if (previewParams.length) {
            const url = new URL(location.href);
            previewParams.forEach(([key, value]) => url.searchParams.set(key, value));
            history.replaceState(history.state, '', url);
          }
        }, {signal: this.events.signal});
        product.addEventListener('click', event => {
          const recommendationLink = event.target.closest('.icraft-recommendations-jump');
          if (recommendationLink) {
            if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            const destination = document.getElementById(recommendationLink.hash.slice(1));
            if (!destination) return;
            event.preventDefault();
            event.stopPropagation();
            this.recommendationAnimation?.cancel();
            if (location.hash !== recommendationLink.hash) history.pushState(history.state, '', recommendationLink.hash);
            destination.scrollIntoView({block: 'start', behavior: 'instant'});
            destination.focus({preventScroll: true});
            if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
              this.recommendationAnimation = destination.animate(
                [{opacity: 0.6, transform: 'translateY(24px)'}, {opacity: 1, transform: 'translateY(0)'}],
                {duration: 220, easing: 'ease-out'}
              );
            }
            return;
          }
          const ratingLink = event.target.closest('[data-icraft-rating-link]');
          if (ratingLink) {
            event.preventDefault();
            this.select(this.tabs[0]);
            const destination = product.querySelector(ratingLink.getAttribute('href'));
            if (destination) requestAnimationFrame(() => {
              destination.focus({preventScroll: true});
              destination.scrollIntoView({block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
            });
            return;
          }
          if (event.target.closest('.jdgm-preview-badge,[href="#judgeme_product_reviews"]')) {
            this.select(this.tabs[0]);this.scrollIntoView({block:'start', behavior:'smooth'});
          }
          const thumb = event.target.closest('.media-thumbs__item');
          if (thumb) {
            const item = product.querySelector(`.media-viewer__item[data-media-id="${thumb.dataset.mediaId}"]`);
            item?.querySelector('icraft-deferred-media')?.loadContent();
          }
        }, {signal: this.events.signal});
        document.addEventListener('visibilitychange', () => {if (document.hidden) window.pauseAllMedia?.(product);}, {signal: this.events.signal});
      }
      initPurchaseScroll(product) {
        const columns = [...product.querySelectorAll(':scope > .product-info, :scope > .icraft-product-left')];
        if (!columns.length) return;
        const desktop = matchMedia('(min-width: 1024px)');
        let previousY = window.scrollY;
        let positions = [];
        const measure = () => {
          previousY = window.scrollY;
          const bottomGap = parseFloat(getComputedStyle(product).getPropertyValue('--icraft-purchase-bottom')) || 24;
          positions = columns.map(column => {
            const currentTop = column.getBoundingClientRect().top;
            column.style.removeProperty('--icraft-purchase-offset');
            if (!desktop.matches) return null;
            const headerEnd = parseFloat(getComputedStyle(product).getPropertyValue('--header-end')) || 100;
            const topLimit = Math.max(12, headerEnd + 12);
            const bottomLimit = Math.min(topLimit, window.innerHeight - column.offsetHeight - bottomGap);
            const offset = Math.max(bottomLimit, Math.min(topLimit, currentTop));
            column.style.setProperty('--icraft-purchase-offset', `${offset}px`);
            return {column, topLimit, bottomLimit, offset};
          }).filter(Boolean);
        };
        const update = () => {
          this.purchaseScrollFrame = null;
          const currentY = window.scrollY;
          if (desktop.matches) {
            positions.forEach(position => {
              position.offset = Math.max(position.bottomLimit, Math.min(position.topLimit, position.offset + previousY - currentY));
              position.column.style.setProperty('--icraft-purchase-offset', `${position.offset}px`);
            });
          }
          previousY = currentY;
        };
        window.addEventListener('scroll', () => {
          if (!this.purchaseScrollFrame) this.purchaseScrollFrame = requestAnimationFrame(update);
        }, {passive: true, signal: this.events.signal});
        window.addEventListener('resize', measure, {passive: true, signal: this.events.signal});
        desktop.addEventListener('change', measure, {signal: this.events.signal});
        this.purchaseResize = new ResizeObserver(measure);
        columns.forEach(column => this.purchaseResize.observe(column));
        measure();
      }
      disconnectedCallback() {this.events?.abort();this.recommendationAnimation?.cancel();this.purchaseResize?.disconnect();cancelAnimationFrame(this.purchaseScrollFrame);}
      select(tab) {
        this.tabs.forEach(item => {item.setAttribute('aria-selected', String(item === tab));item.tabIndex = item === tab ? 0 : -1;});
        this.panels.forEach(panel => {panel.hidden = panel.id !== tab.getAttribute('aria-controls');panel.tabIndex = panel.hidden ? -1 : 0;});
      }
    });
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["icraft-product-qa-demo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('icraft-qa-demo')) {
    customElements.define('icraft-qa-demo', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const button = this.querySelector('[data-qa-submit]');
        const status = this.querySelector('.icraft-qa-status');
        const fields = [...this.querySelectorAll('input, textarea')];
        button.disabled = false;
        button.addEventListener('click', () => {
          for (const field of fields) {
            field.value = field.value.trim();
            if (!field.reportValidity()) return;
          }
          status.hidden = false;
          status.focus({preventScroll: true});
        });
        fields.forEach(field => field.addEventListener('input', () => { status.hidden = true; }));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["icraft-series-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('icraft-series-menu')) {
    customElements.define('icraft-series-menu', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const opts = { signal: this.controller.signal };
        this.disclosure = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.panel = this.querySelector('.icraft-series-panel');
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
        this.desktop = matchMedia('(min-width: 769px)');
        this.hover = matchMedia('(hover: hover)');
        this.carouselSync = [];
        this.carouselStops = [];
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        const position = () => {
          this.querySelector('[role="tablist"]').setAttribute('aria-orientation', this.desktop.matches ? 'vertical' : 'horizontal');
          if (!this.desktop.matches) return;
          const rect = this.summary.getBoundingClientRect();
          const width = Math.min(790, innerWidth - 48);
          this.panel.style.setProperty('--icraft-menu-left', `${Math.max(24, Math.min(rect.left - 170, innerWidth - width - 24))}px`);
          this.panel.style.setProperty('--icraft-menu-top', `${Math.max(0, rect.bottom + 16)}px`);
        };
        this.select = (index, focus = false) => {
          this.tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; this.panels[i].hidden = i !== index; });
          if (focus) this.tabs[index].focus();
          this.carouselSync.forEach(sync => sync());
        };
        this.addEventListener('pointerenter', () => { clearTimeout(this.closeTimer); if (this.desktop.matches && this.hover.matches) { document.querySelectorAll('icraft-series-menu details[open]').forEach(details => { if (details !== this.disclosure) details.open = false; }); position(); this.disclosure.open = true; } }, opts);
        this.addEventListener('pointerleave', () => { if (this.desktop.matches && this.hover.matches) this.closeTimer = setTimeout(() => { if (!this.contains(document.activeElement)) this.disclosure.open = false; }, 180); }, opts);
        this.panel.addEventListener('pointerenter', () => clearTimeout(this.closeTimer), opts);
        this.disclosure.addEventListener('toggle', position, opts);
        this.summary.addEventListener('click', position, opts);
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('pointerenter', () => { if (this.desktop.matches && this.hover.matches) this.select(index); }, opts);
          tab.addEventListener('focus', () => this.select(index), opts);
          tab.addEventListener('click', () => this.select(index), opts);
          tab.addEventListener('keydown', event => {
            let next = index;
            if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else return;
            event.preventDefault(); this.select(next, true);
          }, opts);
        });
        this.addEventListener('keydown', event => { if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); this.disclosure.open = false; this.summary.focus(); } }, opts);
        document.addEventListener('pointerdown', event => { if (!this.contains(event.target)) this.disclosure.open = false; }, opts);
        document.addEventListener('focusin', event => { if (!this.contains(event.target)) this.disclosure.open = false; }, opts);
        window.addEventListener('resize', position, opts);
        window.addEventListener('scroll', () => { if (this.desktop.matches && this.disclosure.open) position(); }, { ...opts, passive: true });
        this.querySelectorAll('[data-menu-carousel]').forEach(carousel => {
          const slides = [...carousel.querySelectorAll('.icraft-menu-slide')];
          const controls = carousel.querySelector('.icraft-menu-carousel-controls');
          if (!controls || slides.length < 2) return;
          controls.hidden = false;
          const dots = [...controls.querySelectorAll('[data-slide-index]')];
          const playback = controls.querySelector('[data-slide-pause]');
          let active = 0, timer, hovered = false, paused = false;
          const stop = () => clearTimeout(timer);
          const show = index => {
            active = (index + slides.length) % slides.length;
            const template = slides[active].querySelector('template');
            if (template) template.replaceWith(template.content.cloneNode(true));
            slides.forEach((slide, i) => { slide.hidden = i !== active; });
            dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === active)));
          };
          const canPlay = () => this.disclosure.open && !carousel.closest('[role="tabpanel"]').hidden && carousel.getClientRects().length > 0 && !document.hidden && !hovered && !carousel.contains(document.activeElement) && !paused && !this.reducedMotion.matches;
          const sync = () => {
            stop();
            playback.hidden = this.reducedMotion.matches;
            if (canPlay()) timer = setTimeout(() => { if (canPlay()) show(active + 1); sync(); }, 4200);
          };
          this.carouselSync.push(sync);
          this.carouselStops.push(stop);
          controls.addEventListener('click', event => {
            const dot = event.target.closest('[data-slide-index]');
            if (dot) show(Number(dot.dataset.slideIndex));
            if (event.target.closest('[data-slide-pause]')) { paused = !paused; playback.textContent = paused ? '▷' : 'Ⅱ'; playback.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow'); }
            sync();
          }, opts);
          carousel.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hovered = true; sync(); } }, opts);
          carousel.addEventListener('pointerleave', () => { hovered = false; sync(); }, opts);
          carousel.addEventListener('focusin', sync, opts);
          carousel.addEventListener('focusout', () => queueMicrotask(sync), opts);
          this.disclosure.addEventListener('toggle', sync, opts);
          this.closest('main-menu')?.addEventListener('toggle', sync, { ...opts, capture: true });
          document.addEventListener('visibilitychange', sync, opts);
          this.reducedMotion.addEventListener('change', sync, opts);
          window.addEventListener('resize', sync, opts);
          sync();
        });
        position();
      }
      disconnectedCallback() { this.carouselStops?.forEach(stop => stop()); this.controller?.abort(); this.controller = null; clearTimeout(this.closeTimer); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["icraft-thumbnail-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('icraft-thumbnail-rail')) {
  customElements.define('icraft-thumbnail-rail',class extends HTMLElement {
    connectedCallback() {
      this.events=new AbortController();
      this.list=this.querySelector('.media-thumbs');
      this.previous=this.querySelector('[data-thumb-scroll=previous]');
      this.next=this.querySelector('[data-thumb-scroll=next]');
      if (!this.list || !this.previous || !this.next) return;
      const update=()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.update());};
      this.list.addEventListener('scroll',update,{passive:true,signal:this.events.signal});
      this.previous.addEventListener('click',()=>this.move(-1),{signal:this.events.signal});
      this.next.addEventListener('click',()=>this.move(1),{signal:this.events.signal});
      this.closest('.icraft-product')?.addEventListener('on:variant:change',()=>{this.list.scrollTo({left:0,top:0,behavior:'instant'});update();},{signal:this.events.signal});
      this.resize=new ResizeObserver(update);
      this.resize.observe(this.list);
      this.changes=new MutationObserver(update);
      this.changes.observe(this.list,{subtree:true,childList:true,attributes:true,attributeFilter:['style','class']});
      update();
    }
    disconnectedCallback() {this.events?.abort();this.resize?.disconnect();this.changes?.disconnect();cancelAnimationFrame(this.frame);}
    vertical() {return getComputedStyle(this.list).flexDirection==='column';}
    update() {
      const vertical=this.vertical();
      const position=vertical?this.list.scrollTop:this.list.scrollLeft;
      const max=vertical?this.list.scrollHeight-this.list.clientHeight:this.list.scrollWidth-this.list.clientWidth;
      const overflow=max>2;
      this.previous.hidden=!overflow;this.next.hidden=!overflow;
      this.previous.disabled=position<=1;this.next.disabled=position>=max-1;
    }
    move(direction) {
      const vertical=this.vertical();
      const distance=(vertical?this.list.clientHeight:this.list.clientWidth)*.8*direction;
      this.list.scrollBy({[vertical?'top':'left']:distance,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
